import React from "react";
import { Link } from "react-router-dom";
import { Logo, GradientBar } from "@/components/design-system";

/** Split-screen shell used for all auth pages. Left = solid Navy with logo,
 *  Right = form on white. Follows brand rules (gradient accent line, no gradient behind text). */
export default function AuthLayout({ eyebrow, title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-white">
      {/* Left: Navy */}
      <div className="hidden md:flex flex-col justify-between bg-[#0B1F3A] p-12 text-white relative overflow-hidden">
        <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full opacity-30" style={{ background: "radial-gradient(circle,#2D7FF9 0%,transparent 60%)" }} />
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full opacity-25" style={{ background: "radial-gradient(circle,#7ED957 0%,transparent 60%)" }} />
        <div className="relative z-10" aria-hidden="true" />
        <div className="relative z-10 max-w-md">
          <Link to="/" className="inline-block mb-8">
            <Logo variant="dark" height={280} />
          </Link>
          <div className="w-24">
            <GradientBar />
          </div>
          <h2 className="font-[Montserrat] font-extrabold text-4xl mt-6 tracking-tighter leading-tight">Validate. Launch. Grow.</h2>
          <p className="mt-4 text-white/75 leading-relaxed">The AI-powered launch infrastructure for SaaS. Join a community of qualified experts and verified ambassadors.</p>
          <div className="mt-8 space-y-3 text-sm text-white/75">
            <div className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#20C7E8]" />GDPR-first · EU data residency</div>
            <div className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#7ED957]" />12-month recurring commissions</div>
            <div className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-[#2D7FF9]" />No card data ever touches our servers</div>
          </div>
        </div>
        <div className="relative z-10 text-xs text-white/50">© {new Date().getFullYear()} Pastoria Project SL</div>
      </div>

      {/* Right: form */}
      <div className="flex flex-col justify-center px-6 md:px-16 py-14">
        <div className="max-w-md w-full">
          <Link to="/" className="md:hidden inline-block mb-8"><Logo variant="light" height={54} /></Link>
          {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#2D7FF9]">{eyebrow}</p>}
          <h1 className="font-[Montserrat] font-extrabold text-3xl md:text-4xl mt-2 text-[#0B1F3A] tracking-tight leading-tight">{title}</h1>
          {subtitle && <p className="mt-3 text-[#0B1F3A]/70">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-[#0B1F3A]/70">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
